module.exports = __webpack_public_path__ + "static/img/img10.e340006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img10.png
// module id = KxOY
// module chunks = 1